<template>
  <section class="service">
    <!-- 顶栏 -->
    <AppHeader />

    <div class="page">
      <!-- 轮播横幅 -->
      <div class="banner">
        <div
          class="b-track"
          :class="{ dragging }"
          :style="trackStyle"
          @touchstart="onDragStart"
          @touchmove="onDragMove"
          @touchend="onDragEnd"
          @mousedown="onDragStart"
          @mousemove="onDragMove"
          @mouseup="onDragEnd"
          @mouseleave="onDragEnd"
        >
          <img src="/recovered-assets/b2n.jpg" alt="" draggable="false" />
          <img src="/recovered-assets/b1.jpg" alt="" draggable="false" />
        </div>
        <div class="b-dots">
          <i :class="{ on: slide === 0 }" @click="slide = 0"></i>
          <i :class="{ on: slide === 1 }" @click="slide = 1"></i>
        </div>
      </div>

      <!-- 产品标题 -->
      <h1 class="prod-title">USD ETHW AI Strategy-C Mine Pool</h1>

      <!-- 两个特性卡 -->
      <div class="feat2">
        <div class="feat2-card">
          <svg class="g-ico" viewBox="0 0 24 24"><path d="M4 9h16M16 5l4 4-4 4M20 15H4M8 11l-4 4 4 4" /></svg>
          <span>{{ $t('featNoTransfer') }}</span>
        </div>
        <div class="feat2-card">
          <svg class="g-ico" viewBox="0 0 24 24"><path d="M4 20h16M7 20v-5M12 20v-9M17 20v-13" /></svg>
          <span>{{ $t('featStable') }}</span>
        </div>
      </div>

      <p class="intro">{{ $t('intro') }}</p>

      <!-- 专案特色 -->
      <h2 class="sec-title">{{ $t('features') }}</h2>
      <div class="flist">
        <div class="fitem">
          <svg class="g-ico" viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" /></svg>
          <div class="ft"><b>{{ $t('f1t') }}</b><small>{{ $t('f1s') }}</small></div>
        </div>
        <div class="fitem">
          <svg class="g-ico" viewBox="0 0 24 24"><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z" /></svg>
          <div class="ft"><b>{{ $t('f2t') }}</b><small>{{ $t('f2s') }}</small></div>
        </div>
        <div class="fitem">
          <svg class="g-ico" viewBox="0 0 24 24"><path d="M4 7c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 7v10c0 1.7 3.6 3 8 3s8-1.3 8-3V7" /></svg>
          <div class="ft"><b>{{ $t('f3t') }}</b><small>{{ $t('f3s') }}</small></div>
        </div>
      </div>

      <!-- 常见问题 -->
      <h2 class="sec-title">{{ $t('faqTitle') }}</h2>
      <div class="card faq-card">
        <div v-for="(item, idx) in faqItems" :key="idx" class="faq" @click="toggleFaq(idx)">
          <div class="faq-q">
            <span>{{ item.q }}</span>
            <svg class="caret" :class="{ open: openFaq === idx }" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></svg>
          </div>
          <p v-if="openFaq === idx" class="faq-a">{{ item.a }}</p>
        </div>
      </div>

      <!-- 合作平台 -->
      <h2 class="sec-title">{{ $t('partners') }}</h2>
      <div class="logo-grid">
        <img src="/recovered-assets/t7.webp" alt="" />
        <img src="/recovered-assets/t8.webp" alt="" />
        <img src="/recovered-assets/t9.png" alt="" />
        <img src="/recovered-assets/t10.png" alt="" />
        <img src="/recovered-assets/e0.png" alt="" />
        <img src="/recovered-assets/e1.webp" alt="" />
      </div>
    </div>

    <MobileTabBar current="service" />
  </section>
</template>

<script>
import MobileTabBar from "../components/MobileTabBar.vue";
import LangSwitch from "../components/LangSwitch.vue";
import QuoteSelect from "../components/QuoteSelect.vue";
import AppHeader from "../components/AppHeader.vue";

export default {
  name: "ServiceView",
  components: { MobileTabBar, LangSwitch, QuoteSelect, AppHeader },
  i18n: {
    zh: {
      featNoTransfer: "无须转账",
      featStable: "收入稳定性",
      intro: "致力于打造全球最大的智慧合约云端平台 DEX、IMO、DAO",
      features: "专案特色",
      f1t: "安全可靠",
      f1s: "无需转账，USDT 存入自己钱包 0 风险",
      f2t: "职业稳定性",
      f2s: "专业团队，全年稳定营运",
      f3t: "进入门槛低",
      f3s: "分享节点挖矿收益",
      faqTitle: "常见问题",
      partners: "合作平台",
      q1: "什么是流动性挖矿?",
      a1: "流动性挖矿是基于 AMM（自动做市商）原理开发的流动性挖矿产品，由不同的流动性池组成，每个流动性池有不同的数字货币。您可以向流动性池添加流动性，成为流动性提供者，获得佣金收入以及 USDT 奖励。",
      q2: "我需要如何加入?",
      a2: "参与无损、非保流动性挖矿，需要支付 BNB 矿工费才能参与。BNB 钱包地址只需申请一次，成功后自动激活挖矿权限。",
      q3: "如何提领?",
      a3: "流动性矿池每天都会产生 USDT 收入，您只需在矿池账户页面发起提现，系统就会自动将挖矿收入发送到您的挖矿节点钱包地址，其他地址不提供支持。",
      q4: "流动性挖矿安全吗?",
      a4: "参与无损 web3.0 AI 智慧机器人挖矿，无需转账资产 USDT，只需将稳定币 USDT 存入自己的去中心化钱包，连接矿池节点，即可享受每天流动性挖矿带来的高回报，零风险挖矿，让投资者更有保障。",
    },
    en: {
      featNoTransfer: "No Transfer",
      featStable: "Income Stability",
      intro: "Committed to building the world's largest smart-contract cloud platform: DEX, IMO, DAO",
      features: "Features",
      f1t: "Safe & Reliable",
      f1s: "No transfer; keep USDT in your own wallet, zero risk",
      f2t: "Professional Stability",
      f2s: "Professional team, stable operation all year round",
      f3t: "Low Entry Barrier",
      f3s: "Share node mining rewards",
      faqTitle: "FAQ",
      partners: "Partners",
      q1: "What is liquidity mining?",
      a1: "Liquidity mining is a product built on the AMM (automated market maker) model, made up of different liquidity pools, each holding different digital currencies. You can add liquidity to a pool, become a liquidity provider, and earn commission income and USDT rewards.",
      q2: "How do I join?",
      a2: "To take part in loss-free, non-custodial liquidity mining, a BNB miner fee is required. The BNB wallet address only needs to be applied for once; mining rights are activated automatically after success.",
      q3: "How to withdraw?",
      a3: "The liquidity pool generates USDT income every day. Simply start a withdrawal on the pool account page, and the system automatically sends your mining income to your mining-node wallet address. Other addresses are not supported.",
      q4: "Is liquidity mining safe?",
      a4: "Join loss-free Web3.0 AI robot mining without transferring your USDT — just keep stablecoin USDT in your own decentralized wallet and connect to the pool node to enjoy high daily returns. Zero-risk mining gives investors more protection.",
    },
  },
  data() {
    return {
      openFaq: -1,
      slide: 0,
      dragging: false,
      dragStartX: 0,
      dragOffset: 0,
    };
  },
  mounted() {
    this.startAuto();
  },
  beforeDestroy() {
    this.stopAuto();
  },
  computed: {
    trackStyle() {
      return { transform: `translateX(calc(-${this.slide * 100}% + ${this.dragOffset}px))` };
    },
    faqItems() {
      // 固定 4 条，随语言切换（读 $t，不走后端）
      return [
        { q: this.$t("q1"), a: this.$t("a1") },
        { q: this.$t("q2"), a: this.$t("a2") },
        { q: this.$t("q3"), a: this.$t("a3") },
        { q: this.$t("q4"), a: this.$t("a4") },
      ];
    },
    fullAddress() {
      return sessionStorage.getItem("ADDRESS") || localStorage.getItem("U_ADDRESS") || "";
    },
    displayAddress() {
      const a = this.fullAddress;
      if (!a) return "0x0000...0000";
      if (a.length <= 14) return a;
      return `${a.slice(0, 6)}...${a.slice(-4)}`;
    },
  },
  methods: {
    toggleFaq(idx) {
      this.openFaq = this.openFaq === idx ? -1 : idx;
    },
    pointX(e) {
      if (e.touches && e.touches[0]) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
      return e.clientX;
    },
    onDragStart(e) {
      this.dragging = true;
      this.dragStartX = this.pointX(e);
      this.dragOffset = 0;
      this.stopAuto();
    },
    onDragMove(e) {
      if (!this.dragging) return;
      this.dragOffset = this.pointX(e) - this.dragStartX;
    },
    onDragEnd() {
      if (!this.dragging) return;
      const off = this.dragOffset;
      if (off < -40 && this.slide < 1) this.slide += 1;
      else if (off > 40 && this.slide > 0) this.slide -= 1;
      this.dragging = false;
      this.dragOffset = 0;
      this.startAuto();
    },
    startAuto() {
      if (this.timer) return;
      this.timer = setInterval(() => {
        this.slide = this.slide === 0 ? 1 : 0;
      }, 4000);
    },
    stopAuto() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style scoped>
.service {
  min-height: 100vh;
  padding-bottom: 92px;
  background: transparent;
}

/* 顶栏 */
.topbar {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
}

.coin-sel {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--pool-text);
  font-size: 15px;
  font-weight: 600;
}

.coin-sel img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.coin-sel svg {
  width: 13px;
  height: 13px;
  stroke: var(--pool-muted);
  fill: none;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.addr {
  max-width: 120px;
  height: 30px;
  line-height: 30px;
  padding: 0 14px;
  border-radius: 15px;
  background: linear-gradient(120deg, #3f7bff, #4b86ff);
  color: #fff;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.page {
  padding: 4px 14px 0;
}

/* 轮播横幅 */
.banner {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid var(--pool-line);
}

.b-track {
  display: flex;
  transition: transform 0.4s ease;
  touch-action: pan-y;
  cursor: grab;
}

.b-track.dragging {
  transition: none;
  cursor: grabbing;
}

.b-track img {
  width: 100%;
  flex: none;
  display: block;
  user-select: none;
  -webkit-user-drag: none;
}

.b-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  display: flex;
  justify-content: center;
  gap: 6px;
}

.b-dots i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
}

.b-dots i.on {
  width: 16px;
  border-radius: 4px;
  background: #f7bd55;
}

/* 产品标题 */
.prod-title {
  text-align: center;
  margin: 24px 0 16px;
  font-size: 19px;
  font-weight: 700;
  color: var(--pool-text);
  text-wrap: balance;
}

/* 两个特性卡 */
.feat2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.feat2-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--pool-glass);
  border: 1px solid var(--pool-line);
  border-radius: var(--pool-r);
  padding: 22px 10px;
  color: var(--pool-text);
  font-size: 15px;
  box-shadow: 0 20px 40px -34px rgba(0, 0, 0, 0.9);
}

.feat2-card .g-ico {
  width: 30px;
  height: 30px;
  margin: 0 auto 14px;
}

.g-ico {
  stroke: #f7bd55;
  fill: none;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.intro {
  margin: 18px 4px 0;
  text-align: center;
  color: var(--pool-muted);
  font-size: 13px;
  line-height: 1.6;
}

/* 区块标题 */
.sec-title {
  text-align: center;
  margin: 26px 0 14px;
  font-size: 20px;
  font-weight: 700;
  color: var(--pool-text);
}

/* 专案特色 */
.flist {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fitem {
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--pool-glass);
  border: 1px solid var(--pool-line);
  border-radius: var(--pool-r);
  padding: 16px 16px;
  box-shadow: 0 20px 40px -34px rgba(0, 0, 0, 0.9);
}

.fitem .g-ico {
  width: 30px;
  height: 30px;
  flex: none;
}

.ft {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ft b {
  color: var(--pool-text);
  font-size: 16px;
}

.ft small {
  color: var(--pool-muted);
  font-size: 12px;
}

/* 卡片 + FAQ */
.card {
  background: var(--pool-glass);
  border: 1px solid var(--pool-line);
  border-radius: var(--pool-r);
  padding: 2px 14px;
  box-shadow: 0 20px 40px -34px rgba(0, 0, 0, 0.9);
}

.faq {
  padding: 14px 0;
  border-bottom: 1px solid var(--pool-line);
  cursor: pointer;
}

.faq:last-child {
  border-bottom: 0;
}

.faq-q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  color: var(--pool-text);
  font-size: 15px;
  font-weight: 600;
}

.caret {
  width: 16px;
  height: 16px;
  flex: none;
  stroke: var(--pool-muted);
  fill: none;
  stroke-width: 2;
  transition: transform 0.2s ease;
}

.caret.open {
  transform: rotate(180deg);
}

.faq-a {
  margin: 10px 0 0;
  color: var(--pool-muted);
  font-size: 13px;
  line-height: 1.7;
  word-break: break-word;
}

/* 合作平台 */
.logo-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 4px 0 8px;
}

.logo-grid img {
  width: 100%;
  height: 54px;
  object-fit: contain;
  background: #eef1f6;
  border-radius: 12px;
  padding: 12px 16px;
  box-sizing: border-box;
}
</style>
